import { useState } from "react";
import { VideoLightbox } from "./VideoLightbox";

interface Props {
  className?: string;
  text?: string;
  onClick?: () => void;
  enableHover?: boolean;
  hoverDuration?: number;
  videoUrl?: string;
  disabled?: boolean;
}

export const LargeButton = ({
  className = "",
  text = "LARGE BUTTON",
  onClick,
  enableHover = true,
  hoverDuration = 200,
  videoUrl,
  disabled = false,
}: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    if (text === "WATCH HIGHLIGHTS" && videoUrl) {
      setIsVideoOpen(true);
    } else if (onClick) {
      onClick();
    }
  };

  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer";

  return (
    <>
      <div
        className={`relative w-80 h-[60px] ${className} ${disabledStyles}`}
        onClick={handleClick}
        onMouseEnter={() => !disabled && enableHover && window.innerWidth >= 768 && setIsHovered(true)}
        onMouseLeave={() => !disabled && enableHover && window.innerWidth >= 768 && setIsHovered(false)}
        data-forever-yours-mode={window.innerWidth < 640 ? "mobile" : "desktop"}
      >
        {/* Default state */}
        <div
          className={`absolute inset-0 transition-opacity duration-${hoverDuration} border border-solid border-[var(--fy-grey)] flex items-center justify-center
            pt-3 pb-[11.25px] px-px rounded-[50px]
            max-md:border-[#657d84] max-md:rounded-[56.35px] max-md:pt-[13.52px] max-md:pb-[12.68px] max-md:px-[1.13px]`}
          style={{ opacity: isHovered && window.innerWidth >= 768 ? 0 : 1 }}
        >
          <div className="flex-1 text-center relative text-[var(--fy-grey)]
            [font-family:var(--button-large-font-family)]
            [font-size:var(--button-large-font-size)]
            [font-weight:var(--button-large-font-weight)]
            [letter-spacing:var(--button-large-letter-spacing)]
            [line-height:var(--button-large-line-height)]
            [text-transform:var(--button-large-text-transform)]
            max-md:[font-family:'Open_Sans',Helvetica]
            max-md:text-[15.8px]
            max-md:tracking-[1.13px]
            max-md:leading-[19.7px]
            max-md:font-normal">
            {text}
          </div>
        </div>

        {/* Hover state */}
        <div
          className={`absolute inset-0 transition-opacity duration-${hoverDuration} border border-solid border-[var(--fy-grey)] bg-[var(--fy-grey)] flex items-center justify-center
            pt-3 pb-[11.25px] px-px rounded-[50px]
            max-md:border-[#657d84] max-md:rounded-[56.35px] max-md:pt-[13.52px] max-md:pb-[12.68px] max-md:px-[1.13px]`}
          style={{ opacity: isHovered && window.innerWidth >= 768 ? 1 : 0 }}
        >
          <div className="flex-1 text-center relative text-[var(--fy-greyfade)]
            [font-family:var(--button-large-font-family)]
            [font-size:var(--button-large-font-size)]
            [font-weight:var(--button-large-font-weight)]
            [letter-spacing:var(--button-large-letter-spacing)]
            [line-height:var(--button-large-line-height)]
            [text-transform:var(--button-large-text-transform)]
            max-md:[font-family:'Open_Sans',Helvetica]
            max-md:text-[15.8px]
            max-md:tracking-[1.13px]
            max-md:leading-[19.7px]
            max-md:font-normal
            max-md:text-neutral-100">
            {text}
          </div>
        </div>
      </div>

      {videoUrl && text === "WATCH HIGHLIGHTS" && (
        <VideoLightbox
          isOpen={isVideoOpen}
          onClose={() => setIsVideoOpen(false)}
          videoUrl={videoUrl}
        />
      )}
    </>
  );
}; 